import { render, staticRenderFns } from "./TitledPageBreak.vue?vue&type=template&id=5317ffc3&scoped=true&"
import script from "./TitledPageBreak.vue?vue&type=script&lang=js&"
export * from "./TitledPageBreak.vue?vue&type=script&lang=js&"
import style0 from "./TitledPageBreak.vue?vue&type=style&index=0&id=5317ffc3&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5317ffc3",
  null
  
)

export default component.exports